import React from "react";
import PageWrapper from "./Practice.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import PracticeTable from "components/practice/PracticeTable";

const Practice = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.practice"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.practice"
          }
        ]}
      />
      <div className="user-tbl">
        <PracticeTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(Practice);
